<template>
  <v-row>
    <v-col>
      <v-app-bar :color="color ? color : 'primary'" dark>
        <v-toolbar-title>
          <slot></slot>
        </v-toolbar-title>
      </v-app-bar>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "AppTitle",
  props: ["color"]
};
</script>

<style>
.capitalize {
  text-transform: capitalize;
}
</style>
